<tcm-main-frame [isLoading]="isLoading" titleKey="Screens.Appointments.VideoRecordings.VideoPlayer.Title">
    <ng-container commands>
        <button class="btn btn-default me-4"
                (click)="back()">{{'Common.SearchActionsAndDetailsActions.Close' | translate}}</button>
    </ng-container>
    <ng-container body>
        <div>
            <video *ngIf="link"
                   [src]="link"
                   controls
                   oncontextmenu="return false;"
                   disablePictureInPicture
                   controlsList="nodownload"
                   [attr.autoplay]="autoplay ? '' : null">                
            </video>
        </div>
    </ng-container>
</tcm-main-frame>